import merge from 'deepmerge'
import MapsCrudRoutes from './MapsCrudRoutes'

const routes = merge.all([MapsCrudRoutes])

export default routes;

